import { css, useTheme } from "@emotion/react";

import parseStyle from "./parseStyle.js";
import useClickable from "./useClickable.jsx";

export default function Clickable(inProps) {
  const theme = useTheme();
  // We won't pass the props through `useThemeProps` because that's handled by `useClickable`.
  const { Element, props } = useClickable(inProps);
  let { children, style, hoverStyle, focusStyle, activeStyle, ...restProps } =
    props;
  return (
    <Element
      css={css`
        ${parseStyle(style, theme)}

        &.wsui-is-interactive:hover,
        &:focus,
        input:focus + &:is(label) {
          ${parseStyle(hoverStyle, theme)};
        }

        &:focus-visible,
        input:focus-visible + &:is(label) {
          ${parseStyle(focusStyle, theme)};
        }

        &.wsui-is-interactive:active,
        &[aria-current],
        input:checked + &.wsui-is-interactive:is(label) {
          ${parseStyle(activeStyle, theme)};
        }
      `}
      {...restProps}
    >
      {children}
    </Element>
  );
}
